import { oc } from "@orpc/contract";
import { z } from "zod";
import {
  workerScalingPageSchema,
  workerScalingSettingsSchema,
  resolvedWorkerScalingSettingsSchema,
} from "@erp/shared-types";

export const workerScalingContracts = {
  get: oc.input(z.object({})).output(workerScalingPageSchema).route({
    summary: "Get background worker scaling settings",
    description:
      "Admin only. Returns the workflow worker pool's autoscaling mode, minimum and maximum worker counts, their source, and current scaling status.",
    method: "POST",
  }),
  save: oc
    .input(
      z.object({
        // Echo the displayed pool so a stale browser cannot save to a changed target.
        pool: z.string().min(1),
        environment: z.string().min(1),
        settings: workerScalingSettingsSchema,
        expectedRevision: z.string().nullable(),
      }),
    )
    .output(resolvedWorkerScalingSettingsSchema)
    .route({
      summary: "Update background worker scaling settings",
      description:
        "Admin only. Saves autoscaling mode and minimum/maximum worker counts for the workflow worker pool; rejects stale edits via a revision check.",
      method: "POST",
    }),
};
